module.exports = __webpack_public_path__ + "static/media/thumbnail.c0b3905e.jpg";